import emojiRegexFactory from 'emoji-regex';

// emoji-regex doesn't match some emojis
// https://github.com/mathiasbynens/emoji-regex/issues/59
const rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]';
const rsEmoji = `(?:${rsSurrPair})`;

const unifiedEmojiSplit = `(${emojiRegexFactory().source}|${rsEmoji})`;
export const unifiedEmojiSplitRegexp = new RegExp(unifiedEmojiSplit, 'i');

const markdownEmojiSplit = `(${emojiRegexFactory().source}|${rsEmoji}|:[\\w+-]+:(?::skin-tone-[2-6]:)?)`;
export const markdownEmojiSplitRegexp = new RegExp(markdownEmojiSplit, 'i');
